import {Form} from 'antd';
import SubmitButton from 'components/Startup/components/SubmitButton';
import styles from './settings.module.scss';
import {useEffect} from 'react';
import {NavTabsEnum} from 'utils/constants';
import {useSelector} from 'react-redux';
import {makeSelectTabOperations} from 'redux/store/auth';

export const BaseSettings = ({handleSave, existingValues}) => {
  const [form] = Form.useForm();
  // const {Option} = Select;

  const pageOperations = useSelector(state =>
    makeSelectTabOperations(state, NavTabsEnum.assetClasses),
  );

  useEffect(() => {
    if (existingValues) {
      form.setFieldsValue({
        // publicAudience:
        //   existingValues?.publicAudience ||
        //   existingValues?.settings?.publicAudience ||
        //   [],
        isPaused:
          existingValues?.isPaused || existingValues?.settings?.isPaused,
        isVisible:
          existingValues?.isVisible || existingValues?.settings?.isVisible,
        shouldNotifyUsersOnLaunch:
          existingValues?.shouldNotifyUsersOnLaunch ||
          existingValues?.settings?.shouldNotifyUsersOnLaunch,
        forDabaPro: existingValues?.forDabaPro,
      });
    }
  }, [existingValues]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h1>Settings</h1>
      </div>
      <div>
        <Form form={form} onFinish={handleSave} layout="vertical">
          {/* <Form.Item name="publicAudience" label="Public Audience">
            <Select
              style={{width: 796}}
              mode="tags"
              allowClear
              placeholder="Select a Public Audience">
              <Option key="INVITED_USERS">Invited Users</Option>
              <Option key="MEMBERS_INVITED_GROUPS">
                Members of Invited Groups
              </Option>
            </Select>
          </Form.Item> */}

          <SubmitButton disabled={!pageOperations?.update} label="Continue" />
        </Form>
      </div>
    </div>
  );
};
